import { NO_SHOW_KIND, type QuickSideCard } from '@ehr/shared';

/**
 * ehr#731 (NO_SHOW_CANCELLATION_NOTE_10-29-V4: "Quick add, Measures, Interventions used and
 * Problems and goals are not on this note"): the side panel cards a no-show note leaves off.
 * Generate note and Last session stay. Every other kind keeps what Note settings shows.
 */
export const NO_SHOW_RAIL_OFF: readonly QuickSideCard[] = ['measures', 'changes'];

export function railOffFor(kind: string | null | undefined): {
  quick: boolean;
  cards: QuickSideCard[];
} {
  return kind === NO_SHOW_KIND
    ? { quick: true, cards: [...NO_SHOW_RAIL_OFF] }
    : { quick: false, cards: [] };
}
